export default __webpack_public_path__ + "static/media/common_tick.ec539593.svg";